import type { TableColumnDefinition } from "$components/table";
import type { IntlShape } from "react-intl";

export const getViewColumns = (
  formatMessage: IntlShape["formatMessage"],
  options: { elephant200AdditionsFlagOn: boolean },
): TableColumnDefinition[] => [
  ...(options.elephant200AdditionsFlagOn
    ? [
        {
          field: "status",
          headerName: formatMessage({
            id: "ancRegister.header.status",
            defaultMessage: "Status",
          }),
          width: 110,
          verticalAlignContents: "top" as const,
          alignContents: "left" as const,
        },
      ]
    : []),
  {
    field: "createdAt",
    headerName: formatMessage({
      id: "ancRegister.header.createdAt",
      defaultMessage: "Visit date",
    }),
    width: 90,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "expectedDueDate",
    headerName: formatMessage({
      id: "ancRegister.header.expectedDueDate",
      defaultMessage: "Expected due date",
    }),
    width: 90,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "name",
    headerName: formatMessage({
      id: "ancRegister.header.name",
      defaultMessage: "Name",
    }),
    width: 150,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "cardNumber",
    headerName: formatMessage({
      id: "ancRegister.header.cardNumber",
      defaultMessage: "Card number",
    }),
    width: 140,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "age",
    headerName: formatMessage({
      id: "ancRegister.header.age",
      defaultMessage: "Age",
    }),
    width: 65,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "parity",
    headerName: formatMessage({
      id: "ancRegister.header.parity",
      defaultMessage: "Parity",
    }),
    width: 100,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "lmp",
    headerName: formatMessage({
      id: "ancRegister.header.lmp",
      defaultMessage: "LMP",
    }),
    width: 90,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "gestation",
    headerName: formatMessage({
      id: "ancRegister.header.gestation",
      defaultMessage: "Gestation",
    }),
    width: 80,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "visitNumber",
    headerName: formatMessage({
      id: "ancRegister.header.visitNumber",
      defaultMessage: "Visit number",
    }),
    width: 90,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "counselling",
    headerName: formatMessage({
      id: "ancRegister.header.counselling",
      defaultMessage: "Counselling",
    }),
    width: 110,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  ...(options.elephant200AdditionsFlagOn
    ? [
        {
          field: "llin",
          headerName: formatMessage({
            id: "ancRegister.header.llin",
            defaultMessage: "LLIN provided",
          }),
          width: 90,
          verticalAlignContents: "top" as const,
          alignContents: "left" as const,
        },
      ]
    : []),
  {
    field: "investigations",
    headerName: formatMessage({
      id: "ancRegister.header.investigations",
      defaultMessage: "Investigations performed",
    }),
    width: 110,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "prescriptions",
    headerName: formatMessage({
      id: "ancRegister.header.prescriptions",
      defaultMessage: "Prescriptions",
    }),
    width: 110,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "iptpDose",
    headerName: formatMessage({
      id: "ancRegister.header.iptpDose",
      defaultMessage: "IPTp",
    }),
    width: 60,
    verticalAlignContents: "top",
    alignContents: "left",
  },
];
